import React from 'react'
import PropTypes from 'prop-types'

import { Row } from 'react-bootstrap'
import PageTitle from './PageTitle'
import { ButtonTopRight } from './ButtonTopRight'
import types from '../../types/types'

export const PageHeaderStandar = ({ title, subtitle, className, userRoleId, routeTo, materialUIText, ...attrs }) => {
    
    // Get user from storage
    // const user = auth.getSessionUser();

    return (
        <Row noGutters className="page-header py-4">
            <PageTitle title={title} subtitle={subtitle} className={"text-sm-left mb-3 " + className } />
            {   // Show "button" only if user is ROOT or ADMIN
                (userRoleId === types.USER_ROOT_ID || userRoleId === types.USER_ADMIN_ID) ? 
                    (
                        <ButtonTopRight routeTo={routeTo} materialUIText={materialUIText}/>
                    )
                :   
                    (
                        ''
                    )
            }
        </Row>
    )
}

// PropTypes is necesary in order to obtain "context" in main function attribute.
PageHeaderStandar.contextTypes = {
    t: PropTypes.func
}

export default PageHeaderStandar;